import { environment } from "@environment/environment";

export class UserSSOModel {
  id: string;
  username: string;
  email: string;
  domain: string;
  name: string;
  firstName: string;
  lastName: string;
  roles: string[];
  isManager: boolean;
  accessToken: string;

  private static MANAGER_GROUP = 'APPS_STORELOCATORE_ROLE_GROUP_MANAGER';

  constructor(claims: any, accessToken: string) {
    this.id = claims?.oid ?? '';
    this.username = claims?.preferred_username ?? '';
    this.email = claims.email || this.username;
    this.domain = this.email.includes('@') ? this.email.split('@')[1] : '';
    this.name = claims?.name ?? '';
    this.firstName = claims?.given_name ?? '';
    this.lastName = claims?.family_name ?? '';
    this.roles = claims?.roles ?? [];
    this.isManager = this.roles.includes(environment.adminRoleId);
    this.accessToken = accessToken;

    console.log('Roles del usuario:', this.roles);
    console.log('Es administrador:', this.isManager);
  }

}